import { Card, CardContent } from "@/components/ui/card";
import { Badge } from "@/components/ui/badge";
import EN from "@/constants/en";

type SkillCategoryProps = {
    title: string;
    skills: readonly string[];
};

const SkillCategory = ({ title, skills }: SkillCategoryProps) => (
    <Card className="h-full">
        <CardContent className="pt-6">
            <h3 className="text-lg font-semibold mb-4">{title}</h3>
            <div className="flex flex-wrap gap-2">
                {skills.map((skill, index) => (
                    <Badge key={index} variant="secondary" className="text-sm py-1">
                        {skill}
                    </Badge>
                ))}
            </div>
        </CardContent>
    </Card>
);

const Skills = () => {
    const skillCategories = EN.SKILLS_CATEGORIES;

    return (
        <section id="skills" className="section bg-white">
            <div className="container-custom">
                <h2 className="section-title">{EN.SKILLS_SECTION_TITLE}</h2>
                <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6">
                    {skillCategories.map((category, index) => (
                        <SkillCategory key={index} title={category.title} skills={category.skills} />
                    ))}
                </div>
            </div>
        </section>
    );
};

export default Skills;
